module.exports = __webpack_public_path__ + "img/vehicule_dark_mode.f811af5f.svg";